const HASH_MULTIPLIER = 31;
const HUE_RANGE = 360;

export function getInitials(name) {
  return (name || '?')
    .split(' ')
    .filter(Boolean)
    .map(part => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export function getStringHue(value) {
  let hash = 0;
  for (let index = 0; index < (value || '').length; index += 1) {
    hash = (hash * HASH_MULTIPLIER + value.charCodeAt(index)) % HUE_RANGE;
  }
  return hash;
}
